import {
  ADD_TEAM_TABLE_REQUEST, ADD_TEAM_TABLE_FAIL, ADD_TEAM_TABLE_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const TeamTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEAM_TABLE_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ADD_TEAM_TABLE_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ADD_TEAM_TABLE_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default TeamTableReducer;
